import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The change-request list's retired address. The Requests tab of the Work page
 * IS the list now, so a saved deep link arrives there with the tab
 * pre-selected. The DETAIL route at /change-requests/$setId keeps its path;
 * only the list address moved.
 */
export const Route = createFileRoute("/_company/change-requests/")({
  beforeLoad: () => {
    throw redirect({ to: "/my-work", search: { tab: "requests" } });
  },
});
